import { render, staticRenderFns } from "./DesktopNavigationButton.vue?vue&type=template&id=7d37707e&"
import script from "./DesktopNavigationButton.vue?vue&type=script&lang=js&"
export * from "./DesktopNavigationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports